import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { commonLabels } from '../../../utils/CommonLabels';

const useStyles = makeStyles({
	pageTitle: {
		marginBottom: '25px',
		display: 'flex',
		justifyContent: 'center',
		position: 'relative',
	},
});

const StyledBox = styled(Box)`
	width: fit-content;
	margin-inline: auto;
	padding-top: 15px;
`;

const StyledTitleTypography = styled(Box)`
	margin-bottom: 2px;
`;

const PreviewQuestionnaireHeader: React.FC<unknown> = () => {
	const classes = useStyles();
	return (
		<StyledBox>
			<Box
				className={classes.pageTitle}
				data-testid="PreviewQuestionnaireHeader-header"
			>
				<StyledTitleTypography>
					<Typography variant="h1">
						{commonLabels.previewQuestionnaire}
					</Typography>
				</StyledTitleTypography>
			</Box>
		</StyledBox>
	);
};
export default PreviewQuestionnaireHeader;
